/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount = {
  owner: string;
  subaccount?: string | undefined;
};

/** @internal */
export const AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$inboundSchema:
  z.ZodType<
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount,
    z.ZodTypeDef,
    unknown
  > = z.object({
    owner: z.string(),
    subaccount: z.string().optional(),
  });

/** @internal */
export type AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$Outbound = {
  owner: string;
  subaccount?: string | undefined;
};

/** @internal */
export const AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$outboundSchema:
  z.ZodType<
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$Outbound,
    z.ZodTypeDef,
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount
  > = z.object({
    owner: z.string(),
    subaccount: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$ {
  /** @deprecated use `AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$inboundSchema` instead. */
  export const inboundSchema =
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$inboundSchema;
  /** @deprecated use `AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$outboundSchema` instead. */
  export const outboundSchema =
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$outboundSchema;
  /** @deprecated use `AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$Outbound` instead. */
  export type Outbound =
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$Outbound;
}

export function appSchemasV2LedgersLedgerIcrc1MetadataMintingAccountToJSON(
  appSchemasV2LedgersLedgerIcrc1MetadataMintingAccount:
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount,
): string {
  return JSON.stringify(
    AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$outboundSchema.parse(
      appSchemasV2LedgersLedgerIcrc1MetadataMintingAccount,
    ),
  );
}

export function appSchemasV2LedgersLedgerIcrc1MetadataMintingAccountFromJSON(
  jsonString: string,
): SafeParseResult<
  AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AppSchemasV2LedgersLedgerIcrc1MetadataMintingAccount' from JSON`,
  );
}
